import { useEffect, useRef, useState } from "react";
import { decryptData, defaulUrl, fmt } from "../components/const";
import OperationsMagasin from "../Comptability/ModalOpaerationMagasin";
import { Link } from "react-router-dom";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const DbMagasin = () => {
    const profile = decryptData('user_profile');
    const date = new Date();
    const [isloading, setIsloading] = useState(false);
    const [datejour, setDateJour] = useState(date.toISOString().slice(0, 10));
    const [date1, setDate1] = useState(datejour);
    const [date2, setDate2] = useState(datejour);
    const [dashboard, setDashboard] = useState(null);
    const [firstLoad, setFirstLoad] = useState(true);
    const [titre, setTitre] = useState(null);
    const [type, setType] = useState(null);
    const refBtnSend = useRef();
    const [versement, setVersement] = useState(null);
    const [solde, setSolde] = useState(0);
    const [isortie, setIsSortie] = useState(false);

    const global = dashboard?.global;
    const periode = dashboard?.periode;



    const handleSend = () => {
        setIsloading(true);
        let status = 0;
        fetch(`${defaulUrl}dashboard/magasin/${date1}/${date2}`, {
            method: "GET",
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
            }
        }).then((response) => {
            status = response.status;
            return response.json();
        }).then(da => {
            setIsloading(false);
            if (status === 200) setDashboard(da);
        });
    };

    const handleShowModalOperation = (title, type) => {
        setTitre(title);
        setType(type);
    };

    useEffect(() => {
        if (firstLoad) {
            handleSend();
            setFirstLoad(false);
        }
    }, [firstLoad]);

    useEffect(() => {
        if (global)
            setSolde(
                (+global?.paye + (+global?.dette_initiale) + (+global?.entree) + (+global?.avance))
                - (+global?.versement + (+global?.sortie))
            );
    }, [dashboard]);

    // 🧾 Export PDF
    const exportPDF = () => {
        const doc = new jsPDF("l", "mm", "a4");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(`FANSAN TEXTIL - ${profile.magasin.toUpperCase()}`, 14, 15);
        doc.setFontSize(11);
        doc.text(`Rapport du ${date1} au ${date2}`, 14, 22);

        autoTable(doc, {
            startY: 28,
            head: [["Indicateur", "Valeur"]],
            body: [
                ["Factures payées", `${fmt(periode?.paye)} GNF`],
                ["Recouvrement clients", `${fmt(periode?.remboursement)} GNF`],
                ["Versement avances clients", `${fmt(periode?.avance)} GNF`],
                ["Entrées", `${fmt(periode?.entree)} GNF`],
                ["Sorties", `${fmt(periode?.sortie)} GNF`],
                ["Dettes", `${fmt(periode?.dette)} GNF`],
                ["Versements comptabilité", `${fmt(periode?.versement)} GNF`],
                ["Solde périodique", `${fmt(((+periode?.paye + (+periode?.entree) + (+periode?.remboursement) + (+periode?.avance)) - ((+periode?.sortie) + (+periode?.versement))))} GNF`],
            ],
            theme: "grid",
            headStyles: { fillColor: [41, 128, 185], textColor: 255 },
            styles: { fontSize: 9 },
        });

        const y = doc.lastAutoTable.finalY + 10;
        doc.setFontSize(12);
        doc.text("RAPPORT GLOBAL", 14, y);

        autoTable(doc, {
            startY: y + 5,
            head: [["Indicateur", "Montant (GNF)"]],
            body: [
                ["Factures payées", fmt(global?.paye)],
                ["Solde avances clients", fmt(global?.avance)],
                ["Total entrées", fmt(global?.entree)],
                ["Remboursements crédits initiaux", fmt(global?.dette_initiale)],
                ["Factures impayées", fmt(global?.dette)],
                ["Total sorties", fmt(global?.sortie)],
                ["Versements comptabilité", fmt(global?.versement)],
                ["Solde caisse", fmt(solde)],
            ],
            theme: "grid",
            headStyles: { fillColor: [0, 102, 204], textColor: 255 },
            styles: { fontSize: 9 },
        });

        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.text(`Page ${i} / ${pageCount}`, doc.internal.pageSize.width - 30, doc.internal.pageSize.height - 10);
        }

        doc.save(`Dashboard_${profile.magasin}_${datejour}.pdf`);
    };

    return (
        <div className="dashboard">
            {(!dashboard || isloading) && <div className="loader"></div>}

            <div className="row mb-2 p-3 rounded justify-content-between bg-white">
                <div className="col-lg-6">
                    <div className="h4 text-primary">FANSAN TEXTIL - {profile.magasin.toUpperCase()}</div>
                    <span className="text-secondary fs-5">Tableau de bord</span>
                </div>
                <div className="col-lg-3 text-end">
                    <button onClick={exportPDF} className="btn btn-outline-primary">
                        📄 Exporter PDF
                    </button>
                </div>
            </div>

            <div className="dboardMag">
                <div className="row bg-white mt-2   text-secondary justify-content-between align-items-center">
                    <div className="col-lg-2 h5 text-secondary ">
                        Rapport du jour
                    </div>
                    <div className="col-lg-4  ">
                        <div className="modal-footer align-items-center justify-content-end ">
                            <div className="col-lg-4 m-1 text-end ">
                                <input type="date" className="form-control " id="date1" name="date1" defaultValue={date1} onChange={(e) => setDate1(e.target.value)} />
                            </div>
                            <div className="col-lg-4 m-1 text-end">
                                <input type="date" className="form-control " id="date1" name="date2" defaultValue={date2} onChange={(e) => setDate2(e.target.value)} />
                            </div>
                            <div className="col-lg-2  text-end w-auto">
                                <button ref={refBtnSend} type="submit" className="btn btn-primary" onClick={() => handleSend()}><i className="bx bx-search"></i></button>
                            </div>
                        </div>

                    </div>
                    <div className="col-lg-6 modal-footer">
                        <button className="btn btn-outline-success m-1 btn-sm" data-bs-toggle='modal' data-bs-target='#modalOprationMagasin' onClick={() => {
                            setIsSortie(false)
                            setVersement(null);
                            handleShowModalOperation('Enregistrer une entrée de caisse', 'entree')

                        }}><i className="bx bx-plus-circle"></i>Saisir une Entrée</button>
                        <button className="btn btn-outline-danger m-1 btn-sm" data-bs-toggle='modal' data-bs-target='#modalOprationMagasin' onClick={() => {
                            setIsSortie(true)
                            setVersement(null);
                            handleShowModalOperation('Enregistrer une sortie de caisse', 'sortie')
                        }}><i className="bx bx-plus-circle"></i>Saisir une Sortie</button>

                        <button className="btn btn-outline-danger m-1 btn-sm" data-bs-toggle='modal' data-bs-target='#modalOprationMagasin' onClick={() => {
                            setIsSortie(true)
                            setVersement(solde)
                            handleShowModalOperation('Faire un versement', 'comptabilite')

                        }}><i className="bx bx-plus-circle"></i>Faire un Versement</button>
                    </div>


                </div>
                {dashboard && <div className="row">
                    <div className="row row-cols-1 row-cols-md-2 row-cols-xl-4 shadow rounded p-2">

                        <div className="col my-1" hidden>
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-primary ">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="row">
                                            <p className="mb-0 text-secondary">Total factures</p>
                                            <h5 className="my-1  text-primary">{(+periode?.total).toLocaleString()} GNF</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-info">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="row">
                                            <p className="mb-0 text-secondary">Factures payées</p>
                                            <h5 className="my-1  text-info">{(+periode?.paye).toLocaleString()} GNF</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-warning">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="mb-0 text-secondary">Recouvrement clients</p>
                                            <h5 className="my -1 text-warning">{(+periode?.remboursement).toLocaleString()} GNF</h5>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col my-1" >
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-primary">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="mb-0 text-secondary">Versement avance clients</p>
                                            <h5 className="my -1 text-primary">{(+periode?.avance).toLocaleString()} GNF</h5>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-warning">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="w-100">
                                            <p className="mb-0 text-secondary">Entrées</p>
                                            <h5 className="my -1 text-warning">{(+periode?.entree).toLocaleString()} GNF</h5>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-danger">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="mb-0 text-secondary">Dettes</p>
                                            <h5 className="my-1  text-danger">{(+periode?.dette).toLocaleString()} GNF</h5>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-danger">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="w-100">
                                            <p className="mb-0 text-secondary">Sorties</p>
                                            <h5 className="my-1  text-danger">{(+periode?.sortie).toLocaleString()} GNF</h5>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-danger">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="mb-0 text-secondary">Versements comptabilité</p>
                                            <h5 className="my-1  text-danger"> {periode ? `${(+periode?.versement).toLocaleString()} GNF` : ''}</h5>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-success text-success bg-success-subtle">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="mb-0">Solde periodique</p>
                                            <h5 className="my-1  text-success">

                                                {
                                                    (
                                                        ((+periode?.paye + (+ periode?.entree) + (+ periode?.remboursement) + (+ periode?.avance))
                                                            - ((+periode?.sortie) + (+periode?.versement)))).toLocaleString()

                                                } GNF


                                            </h5>
                                        </div>
                                        <div className="widgets-icons-2 rounded-circle bg-success p-3 ms-auto"><img src="./images/solde.png" alt="" className="w-100" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="row row-cols-1 row-cols-md-2 row-cols-xl-5 shadow rounded p-2">
                        <div className=" mt-2 py-2  h5 text-secondary bg-white w-100">
                            Vente sur site
                        </div>

                        <div className="col my-1">
                            <Link to={'/cmd-attente'} className="card h-100 radius-10 border-start border-0 border-3 border-info" title="cliquer pour le details">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="row">
                                            <h6 className="my -1 text-secondary">{parseFloat(global?.nb_cmd_attente)} Commandes en attente</h6>

                                            <h5 className="my-1  text-info">{(+global?.vente_site).toLocaleString()} GNF</h5>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="col my-1">
                            <Link to={'/cmd-valide'} className="card h-100 radius-10 border-start border-0 border-3 border-warning" title="cliquer pour le details">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <h6 className="my -1 text-secondary">{parseFloat(global?.nb_cmd_livre)} Commandes validées</h6>
                                            <h5 className="my -1 text-warning">{(parseFloat(global?.vente_site_livre)).toLocaleString()} GNF</h5>

                                        </div>

                                    </div>
                                </div>
                            </Link>
                        </div>


                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-success">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="mb-0 text-secondary">Total Encaisse du jour</p>
                                            <h5 className="my-1  text-success">{(+periode?.paiement_site).toLocaleString()} GNF</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-success">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="mb-0 text-secondary">Total global payé</p>
                                            <h5 className="my-1  text-success">{(+global?.paiement_cmd).toLocaleString()} GNF</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-danger">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="w-100">
                                            <p className="mb-0 text-secondary">Total livré nom payé</p>
                                            <h5 className="my-1  text-danger">{(+global?.livre_non_paye).toLocaleString()} GNF</h5>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>


                    <div className="row row-cols-1 row-cols-md-2 row-cols-xl-4 shadow rounded p-2">
                        <h4 className="text-secondary mt-2 w-100 py-3 bg-white">Rapport global</h4>
                        <div className="col my-1" hidden>
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-primary">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="mb-0 text-secondary">Total Factures</p>
                                            <h5 className="my-2  text-primary">
                                                {global ? `${(+global?.total).toLocaleString()} GNF` : ''} </h5>
                                        </div>
                                        <div className="widgets-icons-2 p-3 rounded-circle bg-primary text-white ms-auto"><i className='bx bx-calculator fs-1'></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-info">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="mb-0 text-secondary">Factures payées</p>
                                            <h5 className="my-2  text-info">
                                                {global ? `${(+global?.paye).toLocaleString()} GNF` : ''}</h5>
                                        </div>
                                        <div className="widgets-icons-2 p-3 rounded-circle bg-info text-white ms-auto"><img src="./images/receive-money.png" alt="" className="w-100" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col my-1" >
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-warning">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="mb-0 text-secondary">Solde avances clients</p>
                                            <h5 className="my -1 text-warning">  {global ? `${(+global.avance).toLocaleString()} GNF` : ''}</h5>

                                        </div>
                                        <div className="widgets-icons-2 rounded-circle bg-warning text-white ms-auto p-3"><img src="./images/receive-money.png" alt="" className="w-100" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-warning">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="mb-0 text-secondary">Total Entrées</p>
                                            <h5 className="my -1 text-warning"> {global ? `${(+global?.entree).toLocaleString()} GNF` : ''}</h5>

                                        </div>
                                        <div className="widgets-icons-2 rounded-circle bg-warning text-white ms-auto p-3"><img src="./images/receive-money.png" alt="" className="w-100" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-warning">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="mb-0 text-secondary">Remboursement credits initiaux</p>
                                            <h5 className="my-1  text-warning">{global ? `${(+global?.dette_initiale).toLocaleString()} GNF` : ''}</h5>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-danger">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="mb-0 text-secondary">Factures impayées</p>
                                            <h5 className="my-1  text-danger">{global ? `${(+global?.dette).toLocaleString()} GNF` : ''}</h5>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-danger">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="mb-0 text-secondary">Total sorties</p>
                                            <h5 className="my -1 text-danger"> {global ? `${(+global?.sortie).toLocaleString()} GNF` : ''}</h5>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-danger">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="mb-0 text-secondary">Versements comptabilité</p>
                                            <h5 className="my-1  text-danger"> {global ? `${(+global?.versement).toLocaleString()} GNF` : ''}</h5>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col my-1">
                            <div className="card h-100 radius-10 border-start border-0 border-3 border-success bg-success-subtle">
                                <div className="py-4 card-body">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="mb-0 text-success fs-4 fw-bold">Solde Caisse</p>
                                            <h5 className="my-1  text-success">
                                                {solde.toLocaleString()} GNF
                                            </h5>
                                        </div>
                                        <div className="widgets-icons-2 rounded-circle bg-success text-white p-3 ms-auto"><img src="./images/solde.png" alt="" className="w-100" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                }
            </div>

            <OperationsMagasin titre={titre} type={type} solde={solde} isortie={isortie} versement={versement} />
        </div>
    );
};

export default DbMagasin;
